/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { CreditInvoicePagedResponse, FindInvoicesParams } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class InvoicesController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags invoices-controller
   * @name FindInvoices
   * @request GET:/api/v1/wallets/{walletId}/credit-invoices
   */
  findInvoices = ({ walletId, ...query }: FindInvoicesParams, params: RequestParams = {}) =>
    this.http.request<CreditInvoicePagedResponse, any>({
      path: `/v1/wallets/${walletId}/credit-invoices`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static findInvoicesPath = '/v1/wallets/${walletId}/credit-invoices'
  static findInvoicesMethod = 'GET'
  /**
   * No description
   *
   * @tags invoices-controller
   * @name Export2
   * @request GET:/api/v1/wallets/{walletId}/credit-invoices/{id}/export
   */
  export = (walletId: string, id: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/wallets/${walletId}/credit-invoices/${id}/export`,
      method: 'GET',
      ...params,
    })

  static exportPath = '/v1/wallets/${walletId}/credit-invoices/${id}/export'
  static exportMethod = 'GET'
}
